import defaultEnvironments from './environments.json.js';

/**
 * Transform REACT_APP envs to match our "Environment" interface.
 */
const transformToLocalEnvs = () => {
    if (!process.env)
        return {};
    return Object.keys(process.env).reduce((acc, env) => {
        if (env.startsWith('REACT_APP_OVERRIDE_')) {
            const envKey = env.replace('REACT_APP_OVERRIDE_', '').toLowerCase();
            return Object.assign(Object.assign({}, acc), { [envKey]: process.env[env] });
        }
        return acc;
    }, {});
};
/**
 * Override envs for a given environment with the ones passed during
 * build time.
 */
const overrideDefaultEnvs = (overrides) => {
    if (!Object.keys(overrides).length)
        return defaultEnvironments;
    const appEnv = process.env.REACT_APP_ENV;
    const envValues = defaultEnvironments[appEnv];
    return Object.assign({}, defaultEnvironments, {
        [appEnv]: Object.assign(Object.assign({}, envValues), overrides),
    });
};
const transformedEnvs = transformToLocalEnvs();
const environments = overrideDefaultEnvs(transformedEnvs);

export { environments as default };
